var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 13.705,
    height: 17.311,
    viewBox: "0 0 13.705 17.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1775",
    "data-name": "Rectangle 1775",
    width: 13.705,
    height: 17.311,
    fill: "#152c40"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3492",
    "data-name": "Group 3492",
    transform: "translate(0.006 0.074)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3329",
    "data-name": "Group 3329",
    transform: "translate(-0.006 -0.074)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11131",
    "data-name": "Path 11131",
    d: "M6.851,0A6.85,6.85,0,0,0,0,6.783C0,11.476,6.039,16.7,6.294,16.922a.861.861,0,0,0,1.114,0c.3-.223,6.294-5.445,6.294-10.138A6.85,6.85,0,0,0,6.851,0m0,15.115c-1.432-1.36-5.138-5.138-5.138-8.332a5.138,5.138,0,1,1,10.276,0c0,3.167-3.706,6.972-5.138,8.332",
    transform: "translate(0.003 0.053)",
    fill: "#152c40"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11132",
    "data-name": "Path 11132",
    d: "M6.372,3a3,3,0,1,0,3,3,3,3,0,0,0-3-3m0,4.282A1.285,1.285,0,1,1,7.657,6,1.285,1.285,0,0,1,6.372,7.282",
    transform: "translate(0.482 0.478)",
    fill: "#152c40"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.b7d590e3f1e7c90edc27c9df40df8323.svg";
export { ForwardRef as ReactComponent };